import {$api} from "./index";

export const createComment = async (comment) => {
    const {data} = await $api.post('api/comment', comment)
    return data
}

export const fetchComment = async () => {
    const {data} = await $api.get('api/comment')
    return data
}
